import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { ReduxStoreModel } from '../../redux/ReduxModel';
import { connect } from 'react-redux'; // Connecting to Redux
import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import { UserState } from '../../redux/UserReducer';
import StudentStatements from 'src/components/student/StudentStatements';

interface ViewStatementsProps extends RouteComponentProps<{}> {
    User: UserState;
}

interface ViewStatementsState {
}

class ViewStatements extends React.Component<ViewStatementsProps, ViewStatementsState> {
    constructor(props: ViewStatementsProps) {
        super(props);
        bindAllOfThis(this, ViewStatements.prototype);
    }

    render() {
        return <div>
            <StudentStatements />
        </div>;
    }
}

function mapStateToProps(state: ReduxStoreModel) {
    return {
        User: state.User
    };
}

export default connect(mapStateToProps)(ViewStatements);



// WEBPACK FOOTER //
// ./src/pages/public/ViewStatements.tsx